export enum PlanningServerEnum {
  DEFAULT = "DEFAULT",
  SECONDARY = "SECONDARY",
  GEO_ENGINE = "GEO_ENGINE",
  GEO_ENGINE_NORMALIZED = "GEO_ENGINE_NORMALIZED"
}
